export const baseURL = 'https://gigsasa-nodejs.ew.r.appspot.com/v1/';
//export const baseURL = 'http://localhost:65080/v1/';
//export const baseURL = '/v1/';

export const socketEndPoint = 'https://gigsasa-nodejs.ew.r.appspot.com';
//export const socketEndPoint = 'https://gigsasa-nodejs-test.ew.r.appspot.com';
//export const socketEndPoint = 'http://localhost:65080';
